import { mapActions, mapGetters, mapState } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('user', ['watchedUserDetails', 'userData']),
    showMenuToggle() {
      return this.isLoggedIn && this.userData.userName !== this.watchedUserDetails.userName;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onMenuToggle() {
      this.showMenu = !this.showMenu;
    },
    onReportUser() {
      this.setCurrentSmallPopup(MODALS.SMALL_REPORT_USER);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/social/user-profile-overview-header/user-profile-overview-header.js